
<!-- category list modal -->
<nz-drawer
    [nzZIndex]="1100"
    [nzClosable]="false"
    [nzVisible]="categoryVisible"
    nzPlacement="bottom"
    (nzOnClose)="handleCloseCategoryDrawer()"
    [nzBodyStyle]="{ padding: 0 }"
    nzHeight="100vh"
  >
    <ng-container *nzDrawerContent>
      <div class="drawer-body">
        <div class="drawer-body__header">
          <div class="drawer-close" (click)="handleCloseCategoryDrawer()">
              <svg-icon [iconName]="'new/close.svg'" ></svg-icon>
          </div>
          <div class="drawer-title mb-4">{{'CATEGORY' | translate }}</div>
          <div class="drawer-sub-title">
              <span> {{ selectedSubCategoryLabels }} {{'LABELS' | translate }} </span>
              <span (click)="handleClearChecked()">
                <svg-icon [iconName]="'new/delete.svg'"></svg-icon>
              </span>
          </div>
          <div class="drawer-tags h-8">
            <nz-tag class="category-tag" *ngFor="let item of selectedSubCategoryList;" nzMode="closeable" (nzOnClose)="handleCancelChecked(item)">{{ item.categoryName }}</nz-tag>
          </div>
        </div>
        <div class="drawer-body__section">
            <div class="drawer-section__nav">
                <ul class="">
                  <li (click)="handleSelectCategory('')">
                    <div [ngClass]="['category-name',  currentCategoryName === '' ? 'active' : '' ]">
                      <span>{{ 'ORDER_ALL' | translate }}</span>
                    </div>
                  </li>
                  <li  *ngFor="let item of categoryList; " (click)="handleSelectCategory(item.categoryName)">
                    <div [ngClass]="['category-name', currentCategoryName === item.categoryName ? 'active' : '']">
                      <span>{{ item.categoryName }}</span>
                    </div>
                  </li>
                </ul>
            </div>
            <div class="drawer-section__right">
              <ul>
                <li class="m-4">
                    <label nz-checkbox [(ngModel)]="allChecked" (ngModelChange)="handleSelectAll()">
                      {{ 'ORDER_ALL' | translate }}
                    </label> 
                </li>
                <li
                  *ngFor="let child of allSubCategoryList"
                  class="m-4"
                >
                  <label nz-checkbox [(ngModel)]="child.checked">{{ child.categoryName }}</label> 
                </li>
              </ul>
            </div>
        </div>

        <div class="fixed-button">
            <div class="confirm-button" (click)="handleConfirmSelectCategory()">
              <i nz-icon nzType="check" nzTheme="outline"></i>
              {{'CONFIRM' | translate }}
            </div>
        </div>
      </div>
    </ng-container>
</nz-drawer>
